<template>
  <div>
    <el-card style="margin: auto;">
      <div slot="header" class="clearfix">
        <span style="float:left; font-weight: 800">安卓列表</span>
        <!-- <el-button style="float:right" size="small" type="text" @click="show_add">添加新集群</el-button> -->
      </div>
      <el-form inline>
        <div style="float:left">
          <el-form-item label="集群">
            <el-select :value="query_by_cluster" @change="get_namespaces" placeholder="请选择集群">
              <el-option v-for="i in clusters" :key="i.id" :value="i.name" :label="i.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="命名空间">
            <el-select
              defaultValue="default"
              :value="query_by_namespace"
              @change="set_query_namespace"
              placeholder="请选择命名空间"
            >
              <el-option
                v-for="i in namespaces"
                :key="i.metadata.uuid"
                :value="i.metadata.name"
                :label="i.metadata.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="get_androids(1, pageSize)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>

      <el-table :data="androids" :pagination="false" border style="margin-top: 15px;">
        <el-table-column label="名称" prop="metadata.name" width="250"></el-table-column>
        <el-table-column label="数量" prop="spec.replicas"></el-table-column>
        <el-table-column label="最小数量" prop="spec.template.limit.min"></el-table-column>
        <el-table-column label="最大数量" prop="spec.template.limit.max"></el-table-column>
        <el-table-column label="空闲数量" prop="spec.template.limit.free"></el-table-column>
        <el-table-column label="生命周期">
          <template slot-scope="record">
            <el-tag
              type="info"
              size="mini"
              effect="dark"
              v-if="record.row.spec.template.limit.age === null"
            >无限制</el-tag>
            <el-tag
              type="danger"
              size="mini"
              effect="dark"
              v-else
            >{{ record.row.spec.template.limit.age }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否启用GPU">
          <template slot-scope="record">
            <el-tag
              type="success"
              size="mini"
              effect="dark"
              v-if="record.row.spec.template.androidSpec.useGPU === true"
            >启用</el-tag>
            <el-tag type="danger" size="mini" effect="dark" v-else>未启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="metadata.creationTimestamp"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="record">
            <el-button size="mini" type="primary" @click="goto(record.row.metadata.name)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; margin-top: 15px">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="get_androids"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query_by_namespace: "",
      namespaces: [],
      pageSize: 0,
      total: 0,
      androids: [],
      query_by_cluster: "",
      clusters: [],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        endpoint: [
          { required: true, message: "请输入 endpoint 地址", trigger: "blur" },
        ],
      },
    };
  },
  async created() {
    this.pageSize = this.config.pageSize;
    await this.get_clusters();
    console.log("wait", this.clusters);
    if (this.query_by_cluster === "" && this.clusters.length !== 0) {
      this.query_by_namespace = 'test';
      this.get_namespaces(this.clusters[0].name);
      this.get_androids(1, this.pageSize);
    }
  },
  methods: {
    get_clusters() {
      const _this = this;
      return _this.$axios
        .get(_this.config.path + "/k8sclusters?currentPage=0&pageSize=20", {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取集群列表失败: " + res.data.message,
              showClose: true,
              type: "error",
            });
          } else {
            _this.clusters = res.data.data;
          }
        })
        .catch(function (err) {
          _this.$message["error"]({
            message: "获取集群列表失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
    get_namespaces(value) {
      const _this = this;
      _this.query_by_cluster = value;
      _this.namespaces = [];
      _this.$axios
        .get(_this.config.path + "/namespaces?cluster=" + value, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            console.log("get namespaces with error: ", res.data.message);
          } else {
            _this.namespaces = res.data.data;
            console.log("active namespace:", _this.namespaces);
            console.log("all namespace", res.data.data);
          }
        })
        .catch(function (err) {
          console.log("get namepsaces with error: ", err.toString());
        });
    },
    set_query_namespace(value) {
      this.query_by_namespace = value;
      this.get_androids(1, this.pageSize);
    },
    get_androids(page) {
      const _this = this;
      console.log("current page size：", this.pageSize);
      _this.$axios
        .get(
          _this.config.path +
            "/androids?currentPage=" +
            page +
            "&pageSize=" +
            _this.pageSize +
            "&cluster=" +
            _this.query_by_cluster +
            "&namespace=" +
            _this.query_by_namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取安卓列表失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            _this.androids = res.data.data;
            _this.total = res.data.page.totalCount;
            console.log(_this.androids);
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取安卓列表失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
    goto(name) {
      this.$router.push({
        path: `/androidprofile/${this.query_by_cluster}/${this.query_by_namespace}/${name}`,
      });
    },
  },
};
</script>
